import React from 'react';
import styled from 'styled-components';
import TopFooter from './top-footer';
import BottomFooter from './bottom-footer';

const Footer = () => (
  <>
    <TopFooter />
    <BottomFooter />
  </>
);

export default styled(Footer)``;
